/**
 * Created by alvinoktavianus on 6/27/17.
 */

import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON,
  INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON,
  INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE,
  INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL,
  INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE,
  INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT,
  INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE,
  INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS,
  INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL,
  INGREDIENT_SUBSCRIPTION_SET_OUTLETS,
  INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE,
  INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE,
  INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL,
  INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL,
  INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL
} from 'actions/ingredients/ingredientSubscription/constant'

let initialState = {
  featurePrice: {},
  featurePricePerMonths: 0,
  isOnTutorial: null,
  pendingPaymentMessage: null,
  pendingOutletMessage: null,
  isButtonDisabled: false,
  buttonMessage: 'Pay',
  subscriptionDetail: {},
  pageOnLoading: true,
  currentOutletCount: 0,
  showDetailModal: false,
  outletList: [],
  showPaymentGatewayErrorModal: false
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  const {payload = {}} = action
  switch (action.type) {
    case INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS:
      return {...state, featurePricePerMonths: payload.featurePricePerMonths}
    case INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE:
      return {...state, featurePrice: payload.featurePrice}
    case INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE:
      return {...state, pendingPaymentMessage: payload.pendingPaymentMessage}
    case INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON:
      return {...state, isButtonDisabled: false}
    case INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON:
      return {...state, isButtonDisabled: true}
    case INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL:
      return {...state, subscriptionDetail: payload.subscriptionDetail}
    case INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL:
      return {...state, isOnTutorial: payload.isOnTutorial}
    case INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE:
      return {...state, pendingOutletMessage: payload.pendingOutletMessage}
    case INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE:
      return {...state, pageOnLoading: false}
    case INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT:
      return {...state, currentOutletCount: payload.currentOutletCount}
    case INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL:
      return {...state, showDetailModal: true}
    case INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL:
      return {...state, showDetailModal: false}
    case INGREDIENT_SUBSCRIPTION_SET_OUTLETS:
      return {...state, outletList: payload.outlets}
    case INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE:
      return {...state, buttonMessage: payload.buttonMessage}
    case INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL:
      return {...state, showPaymentGatewayErrorModal: true}
    case INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL:
      return {...state, showPaymentGatewayErrorModal: false}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/ingredients/ingredientSubscription.js